import { useIntl } from 'react-intl'
import ErrorPage from './ErrorPage'

/**
 * Forbidden page
 * @constructor
 */
const Forbidden = () => {
	const { formatMessage } = useIntl()

	return (
		<ErrorPage
			code={formatMessage({ id: 'global.errorPages.forbidden.code' })}
			explanation={formatMessage({ id: 'global.errorPages.forbidden.explanation' })}
			message={formatMessage({ id: 'global.errorPages.forbidden.message' })}
		/>
	)
}

export default Forbidden
